import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import {
    LstAuthGuard, LstAuthModule, LstRouterModule
} from '@savvaslearning/lst-auth';
import { defineCustomElements } from '@savvaslearning/cel-components/dist-stencil/loader';
import { Apollo } from 'apollo-angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { GraphQLModule } from './apollo.config';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { WebpackTranslateLoader } from './webpack-translate-loader';
import { lstAuthModuleOptions } from './app.constants';
import { StorageService } from './services/storage.service';

defineCustomElements(window, { transformTagName: (tagName: any) => `google-class-${tagName}` } as any);
@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        LstRouterModule.getRoutes(),
        LstAuthModule.forRoot(lstAuthModuleOptions),
        GraphQLModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: WebpackTranslateLoader,
            },
        }),
    ],
    providers: [
        Apollo,
        StorageService,
        LstAuthGuard,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent],
    exports: [AppComponent],
})
export class AppModule { }
